<template>
    <!-- Inizio repeater -->
    
  <RigaInterventiAssegnati v-for="(intervento, index) in this.listaInterventiShow" 
  :key="index"
  :intervento="intervento"
  :index="index"
  >
  </RigaInterventiAssegnati>  

  <!-- Fine repeater -->  
  
</template>

<script>


import RigaInterventiAssegnati from "@/components/RigaInterventiAssegnati.vue";
export default {
  name: "GrigliaInterventi",
  data(){
    return {
      listaInterventiShow: null     
    }    
  },
  components:{
    RigaInterventiAssegnati
  },  
  props: {
    listaInterventi: Array
  },
  watch:{
    listaInterventi: function(newValue){
      this.listaInterventiShow = newValue;
    }
  }  
};
</script>
